import classNames from 'classnames';
import Avatar from 'components/Avatar';
import InlineMessage from 'components/InlineMessage';
import React, { PureComponent } from 'react';
import FontAwesome from 'react-fontawesome';
import type { HourDraftStatusMessageAction, HourDraftStatusMessages } from 'types/hour';
import styles from './InfoMessagesSection.module.scss';

interface Props {
  standalone?: boolean;
  ui: {
    messages: HourDraftStatusMessages;
  };
  onUnlock?: (event: React.SyntheticEvent) => void;
  onHide?: (event: React.SyntheticEvent) => void;
}

export class InfoMessagesSection extends PureComponent<Props> {
  renderActions = (actions: Array<HourDraftStatusMessageAction>, messageKey: string | number) => {
    // the action here should map to a corresponding function passed in from the parent component
    return actions.map(({ action, label, key }) => (
      <a
        key={key}
        data-key={messageKey}
        onClick={this.props[action] ? this.props[action] : undefined}
        className={styles.unlockButton}
      >
        {label}
      </a>
    ));
  };

  render() {
    const { ui, standalone } = this.props;
    return ui.messages.map(({ key, type, title, message, avatar, icon, actions }) => {
      return (
        <InlineMessage
          className={classNames(styles.inlineMessage, {
            [styles.isStandalone]: standalone,
            [styles.withAvatar]: !!avatar,
            [styles.withIcon]: !!icon,
          })}
          key={key}
          size="small"
          type={type}
        >
          {!!avatar && (
            <div className={styles.avatar}>
              <Avatar size="medium" shape="rounded" src={avatar} tooltip={false} />
            </div>
          )}
          {!!icon && (
            <div className={styles.icon}>
              <FontAwesome name={icon} />
            </div>
          )}
          <div className={styles.text}>
            <h5>{title}</h5>
            {!!actions && !!actions.length ? this.renderActions(actions, key) : message}
          </div>
        </InlineMessage>
      );
    });
  }
}
